import type { Tile } from "../../types";

/**
 * Get a square of slippy tiles around the center tile.
 *
 * @param centerTile - id, x, y, z
 * @param gridSize - 1x1, 3x3, 5x5, etc.
 */
function getTilesGrid(centerTile: Tile, gridSize: number) {
  const { x, y, z } = centerTile;
  const totalTiles = 2 ** z;

  const size = Math.min(gridSize, totalTiles);

  const offset = Math.floor(size / 2);
  const tiles: Tile[] = [];
  const visited = new Set<string>();

  for (let dx = -offset; dx <= offset; dx++) {
    for (let dy = -offset; dy <= offset; dy++) {
      const wrappedX = (x + dx + totalTiles) % totalTiles;
      const wrappedY = (y + dy + totalTiles) % totalTiles;

      const id = `${z}/${wrappedX}/${wrappedY}`;
      if (!visited.has(id)) {
        visited.add(id);
        tiles.push({
          id,
          x: wrappedX,
          y: wrappedY,
          z,
        });
      }
    }
  }

  return tiles;
}

export { getTilesGrid };
